import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { parse } from 'qs'

import Result from './Result'
import Test from './Test'
import Loading from '../components/Loading'
import { actions as appActions } from '../store/app'
import { setNavigatorTitle, setNavigatorBarTheme } from '../services/native'

const pageMap = {
  0: <Test />,
  1: <Test />,
  2: <Result />
}

export default function Main() {
  const { stage } = useSelector(state => state.app)
  const dispatch = useDispatch()

  useEffect(() => {
    const urlQueryObj = parse(window.location.search, {
      ignoreQueryPrefix: true
    })
    const type = urlQueryObj.type === 'listening' ? 2 : 1
    const trace = urlQueryObj.trace || 'mine'
    if (type === 2) {
      setNavigatorTitle('听力词汇量测试')
    } else {
      setNavigatorTitle('阅读词汇量测试')
    }
    setNavigatorBarTheme('F8F8F9', 0, 'F8F8F9').catch(err => console.log(err))
    dispatch(appActions.setTestType(type, trace))
    dispatch(appActions.createPreTest(type))
  }, [dispatch])

  if (stage === -1) return <Loading />
  return <>{pageMap[stage]}</>
}
